const QseReportDataSectionTitle = (props) => {
  const { title, handleClick } = props;

  return (
    <div
      className="alert alert-info pointer mb-2"
      onClick={handleClick}
    >
      {title}
    </div>
  );
};

export default QseReportDataSectionTitle;
